import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RomanticCompatibilityReport from "./component";
import {
  getAssessment,
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  getUserAssessmentResultByResultId,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getTransactionDetail,
  isGuestOrPremiumUser,
} from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInsightfulContentConnect: getInsightfulContent,
      getUserAssessmentResultByResultIdConnect:
        getUserAssessmentResultByResultId,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,

      getAssessmentConnect: getAssessment,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getGuestUserConnect: getGuestUser,
      getTransactionDetailConnect: getTransactionDetail,
      guestUserChangesConnect: createGuestUser,
      getBillingConnect: getBilling,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RomanticCompatibilityReport);
